<template>
  <div class="AutocompleteServicios">
    <v-autocomplete
      v-if="!isSelect && !multiple"
      v-model="valor"
      append-icon="search"
      :error-messages="error"
      item-text="desc_ser"
      item-value="id_ser"
      :items="servicios"
      :label="label ? label : 'Buscar servicio'"
      filled
      @change="_searchAndSendSer"
      @keyup.enter="$emit('enter',true)"
    >
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title v-text="data.item.desc_ser+', '+$nF(data.item.precio_ser)" />
        </v-list-item-content>
      </template>
    </v-autocomplete>
    
    
    <!-- Modo múltiple con selector original pero lista de cantidades -->
    <div v-if="!isSelect && multiple" class="servicios-con-cantidad">
      <v-autocomplete
        v-model="valor"
        append-icon="search"
        multiple
        :error-messages="error"
        item-text="desc_ser"
        item-value="id_ser"
        :items="servicios"
        :label="label ? label : 'Seleccionar servicios'"
        filled
        ref="autocompleteMultiple"
        @change="_handleMultipleSelection"
      >
        <template v-slot:item="data">
          <v-list-item-content>
            <v-list-item-title v-text="data.item.desc_ser+', '+$nF(data.item.precio_ser)" />
          </v-list-item-content>
        </template>
      </v-autocomplete>
      
      <!-- Lista de servicios seleccionados con cantidades -->
      <v-list v-if="serviciosConCantidad.length > 0" class="mt-3">
        <v-subheader>Servicios seleccionados:</v-subheader>
        <div v-for="(servicio, idx) in serviciosConCantidad" :key="servicio.id_ser">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{servicio.desc_ser}}</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field
                  v-model="servicio.cantidad"
                  type="number"
                  min="1"
                  dense
                  hide-details
                  style="max-width: 80px; display: inline-block;"
                  @change="_actualizarCantidad(idx)"
                />
                <span class="ml-2">x {{$nF(servicio.precio_ser)}} = {{$nF(servicio.cantidad * servicio.precio_ser)}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="_eliminarServicio(idx)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>
      </v-list>
    </div>
    
    <v-select
      v-if="isSelect"
      v-model="valor"
      :error-messages="error"
      item-text="desc_ser"
      item-value="id_ser"
      :items="servicios"
      :label="label ? label : 'Seleccionar servicio'"
      filled
      @change="_searchAndSendSer"
    />
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
export default {
  name: "AutocompleteServicios",
  mixins: [forms],
  props: {
    value: [String, Array],
    isSelect: Boolean,
    label: String,
    error: String,
    multiple: Boolean,
  },
  data() {
    return {
      cargando: false,
      servicios: [],
      valor: null,
      // Nueva estructura para servicios con cantidad
      serviciosConCantidad: [],
      cargandoInicial: false, // Bandera para evitar interferencia durante carga inicial
    };
  },
  methods: {
    _searchAndSendSer(a) {
      this.$emit("input", a);
      let i = this.servicios.findIndex(function (b) {
        return b.id_ser === a;
      });
      if (i >= 0) {
        this.$emit("change", this.servicios[i]);
      }
    },
    _handleMultipleSelection(selectedIds) {
      // Crear array de servicios con cantidad basado en la selección
      const nuevosServiciosConCantidad = [];
      
      selectedIds.forEach(id => {
        // Verificar si el servicio ya existe con cantidad personalizada
        const servicioExistente = this.serviciosConCantidad.find(s => s.id_ser === id);
        
        if (servicioExistente) {
          // Mantener la cantidad existente
          nuevosServiciosConCantidad.push(servicioExistente);
        } else {
          // Agregar nuevo servicio con cantidad por defecto
          const servicio = this.servicios.find(s => s.id_ser === id);
          if (servicio) {
            nuevosServiciosConCantidad.push({
              ...servicio,
              cantidad: 1, // Cantidad por defecto (para mostrar en UI)
              qty: 1 // Cantidad en formato backend
            });
          }
        }
      });
      
      this.serviciosConCantidad = nuevosServiciosConCantidad;
      
      // Cerrar el dropdown del autocompletado
      this.$nextTick(() => {
        if (this.$refs.autocompleteMultiple) {
          this.$refs.autocompleteMultiple.blur();
        }
      });
      
      // Emitir los eventos
      this.$emit("input", selectedIds);
      this.$emit("servicios-con-cantidad", this.serviciosConCantidad);
    },
    _eliminarServicio(idx) {
      const servicioEliminado = this.serviciosConCantidad[idx];
      
      // Remover de la lista de servicios con cantidad
      this.serviciosConCantidad.splice(idx, 1);
      
      // Actualizar el valor del autocompletado
      const nuevosIds = this.serviciosConCantidad.map(s => s.id_ser);
      this.valor = nuevosIds;
      
      // Emitir los eventos
      this.$emit("input", nuevosIds);
      this.$emit("servicios-con-cantidad", this.serviciosConCantidad);
      
      this.$emit("msg", "Servicio eliminado");
    },
    _actualizarCantidad(idx) {
      if (this.serviciosConCantidad[idx].cantidad < 1) {
        this.serviciosConCantidad[idx].cantidad = 1;
      }
      
      // Sincronizar qty con cantidad
      this.serviciosConCantidad[idx].qty = this.serviciosConCantidad[idx].cantidad;
      
      // Emitir los servicios actualizados
      this.$emit("servicios-con-cantidad", this.serviciosConCantidad);
    },
    _cargarServiciosIniciales(ids, serviciosConCantidad = null) {
      // Cargar servicios iniciales cuando se pasa un valor
      if (serviciosConCantidad && serviciosConCantidad.length > 0) {
        // Usar los servicios con cantidad proporcionados
        this.serviciosConCantidad = serviciosConCantidad.map(s => ({
          ...s,
          cantidad: parseInt(s.cantidad) || parseInt(s.qty) || 1,
          qty: parseInt(s.qty) || parseInt(s.cantidad) || 1
        }));
      } else {
        // Cargar con cantidad por defecto
        this.serviciosConCantidad = [];
        ids.forEach(id => {
          const servicio = this.servicios.find(s => s.id_ser === id);
          if (servicio) {
            this.serviciosConCantidad.push({
              ...servicio,
              cantidad: 1, // Cantidad por defecto (para mostrar en UI)
              qty: 1 // Cantidad en formato backend
            });
          }
        });
      }
      
      // Emitir el evento para que el componente padre tenga los servicios con cantidad
      if (this.serviciosConCantidad.length > 0) {
        this.$emit("servicios-con-cantidad", this.serviciosConCantidad);
      }
    },
    actualizarServiciosConCantidad(serviciosConCantidad) {
      // Método público para actualizar servicios con cantidad desde el componente padre
      if (serviciosConCantidad && serviciosConCantidad.length > 0) {
        console.log('Actualizando servicios con cantidad en componente hijo:', serviciosConCantidad);
        
        // Activar bandera para evitar interferencia del watcher
        this.cargandoInicial = true;
        
        // Crear una copia profunda para forzar reactividad
        this.serviciosConCantidad = serviciosConCantidad.map(s => {
          const cantidad = parseInt(s.cantidad) || parseInt(s.qty) || 1;
          console.log(`Actualizando servicio ${s.id_ser} con cantidad ${cantidad}`);
          return {
            ...s,
            cantidad: cantidad,
            qty: cantidad
          };
        });
        
        this.valor = serviciosConCantidad.map(s => s.id_ser);
        
        console.log('Servicios actualizados en componente:', this.serviciosConCantidad);
        
        // Desactivar bandera después de un pequeño delay
        this.$nextTick(() => {
          this.cargandoInicial = false;
        });
        
        // Emitir el evento para sincronizar con el padre
        this.$emit("servicios-con-cantidad", this.serviciosConCantidad);
      }
    },
  },
  created() {
    if (this.value) this.valor = this.value;
    this._getThings("servicios?simple=si", "servicios");
  },
  computed: {
    // Ya no necesitamos serviciosDisponibles porque usamos el selector múltiple original
  },
  watch: {
    value(a) {
      this.valor = a;
      // Si se pasa un valor inicial, cargar los servicios correspondientes
      // PERO NO si estamos cargando desde el mixin (cargandoInicial = true)
      if (this.multiple && Array.isArray(a) && a.length > 0 && !this.cargandoInicial) {
        this._cargarServiciosIniciales(a);
      }
    },
    valor(a) {
      // Solo emitir input para modo individual (no múltiple)
      if (!this.multiple) {
        this.$emit("input", a);
      }
    },
  },
};
</script>

<style scoped>
.servicios-con-cantidad {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 16px;
  background-color: #fafafa;
}

.mt-2 {
  margin-top: 8px;
}

.mt-3 {
  margin-top: 16px;
}

.ml-2 {
  margin-left: 8px;
}

.v-list-item-subtitle {
  display: flex;
  align-items: center;
}
</style>